import { storage } from "../../storage";
import {
  isResource,
  isResourceGlobal,
  isResourceRegional,
  isResourceRegionalUsOnly,
  Region,
  Resource,
  US_REGION,
} from "../../types";
import { env } from "../../utils";
import { getBackendPath } from "./BackendPathMapper";

export const mapToResourceAndRegionOrError = (
  input: string,
): { resource: Resource; region?: Region } => {
  if (isResource(input)) {
    return { resource: input };
  }

  const [region, ...rest] = input.split("/");
  const resourceString = rest.join("/");

  if (!isResource(resourceString)) {
    throw new Error(
      `${input} is not a recognized Resource or Region/Resource combination`,
    );
  }

  return { resource: resourceString, region: region };
};

export const computeBackendBaseUrlFor = (
  resource: Resource,
  region?: Region,
): string => {
  if (isResourceGlobal(resource)) {
    return env.base_urls.fetch_for_super();
  }

  if (isResourceRegionalUsOnly(resource)) {
    if (region !== US_REGION) {
      throw new Error(`${resource} is only available in the US region`);
    }
    return storage.getApiBaseUrlForRegion(US_REGION);
  }

  if (!region) throw new Error(`Resource ${resource} requires region`);

  if (isResourceRegional(resource)) {
    return storage.getApiBaseUrlForRegion(region);
  }

  throw new Error(`Resource ${resource} is not supported`);
};

const baseUrl = (resource: Resource, region?: Region): string => {
  return `${computeBackendBaseUrlFor(resource, region)}/${getBackendPath(
    resource,
  )}`;
};

export const buildBaseUrlFor = (resource: string, region?: Region): string => {
  if (region !== undefined) {
    return baseUrl(resource as Resource, region);
  }

  const { resource: parsedResource, region: parsedRegion } =
    mapToResourceAndRegionOrError(resource);
  return baseUrl(parsedResource, parsedRegion);
};
